/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Search_In_ContentInputs */

const cs_blog_filter_search_in_content = /** @type {(inputs: Blog_Filter_Search_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsah`)
};

const en_blog_filter_search_in_content = /** @type {(inputs: Blog_Filter_Search_In_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Blog_Filter_Search_In_ContentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_search_in_content = /** @type {((inputs?: Blog_Filter_Search_In_ContentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Search_In_ContentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_search_in_content(inputs)
	return cs_blog_filter_search_in_content(inputs)
});